var _rect, _rect2, _rect3, _rect4, _rect5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTable08(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 1375,
    viewBox: "-25 -25 1400 2750",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1350,
    height: 2700,
    x: 0,
    y: 0,
    fill: "#C0D0C0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1400,
    height: 25,
    x: -25,
    y: -25,
    fill: "darkgreen"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1400,
    height: 25,
    x: -25,
    y: 2700,
    fill: "darkgreen"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 2750,
    x: -25,
    y: -25,
    fill: "darkgreen"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 2750,
    x: 1350,
    y: -25,
    fill: "darkgreen"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 114,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 1350,
    r: 114,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 2700,
    r: 114,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1350,
    cy: 0,
    r: 114,
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1350,
    cy: 1350,
    r: 114,
    fill: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1350,
    cy: 2700,
    r: 114,
    fill: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 574,
    cy: 694,
    r: 28,
    fill: "YELLOW"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 477,
    cy: 348,
    r: 28,
    fill: "BLUE"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1067,
    cy: 28,
    r: 28,
    fill: "RED"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 676,
    cy: 743,
    r: 28,
    fill: "WHITE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable08);
export default __webpack_public_path__ + "static/media/table08.d6d90f77ec2605d6dbd0027599921f6f.svg";
export { ForwardRef as ReactComponent };